import { createElement, useCallback, useEffect, useState } from "react";
import { getPrivacyPolicies } from "../apis/privacy-policies";
import { PrivacyPolicies } from "../components/PrivacyPoliciesPage/PrivacyPolicies";
import { GroupedSection } from "../util/privacy-policies";

export const PrivacyPoliciesContainer: React.FC = () => {
  const [privacyPolicies, setPrivacyPolicies] = useState<GroupedSection[]>([]);

  const fetchPrivacyPolicies = useCallback(async () => {
    const response = await getPrivacyPolicies();
    setPrivacyPolicies(response);
  }, []);

  useEffect(() => {
    fetchPrivacyPolicies();
  }, [fetchPrivacyPolicies]);

  const props = { privacyPolicies };

  return createElement(PrivacyPolicies, props);
};
